import { styled } from "@mui/material/styles";
import { Box, Link } from "@mui/material";

export const StyledMenuWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  position: "relative",
  width: "100%",

  [theme.breakpoints.down("md")]: {
    width: "100%",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: theme.spacing(1),

    "& .MuiMenuItem-root": {
      width: "100%",
    },

    "& [data-testid='rk-connect-button']": {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      alignSelf: "flex-end",
      background: "transparent",
      borderRadius: theme.spacing(3.75),
      padding: theme.spacing(1, 1),
    },

    "& .ju367v1s": {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(2),
      width: "100%",
      paddingInline: theme.spacing(0.5),

      "& [data-testid='rk-chain-button']": {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        background: "transparent",
        borderRadius: theme.spacing(3.75),
        padding: theme.spacing(1),

        "& .ju367v1p": {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: theme.spacing(0.75),

          "& div > div.iekbcc0": {
            background: "transparent !important",
            height: "30px !important",

            "& img": {
              width: "30px",
              height: "30px",
            },
          },
        },
      },

      "& [data-testid='rk-account-button']": {
        width: "100%",
        padding: theme.spacing(1, 1),
        background: "transparent",
        borderRadius: theme.spacing(3.75),

        "& div.iekbcc0": {
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          gap: theme.spacing(0.75),

          "& div > div.ju367va": {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",

            "& div": {
              width: "fit-content",
            },
          },

          "& div > div.ju367v8": {
            width: "fit-content",

            "& div": {
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "30px !important",
              height: "30px !important",
              fontSize: "24px",
              borderRadius: "50%",
            },
          },
        },
      },
    },
  },
}));

export const StyledMenuTop = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: theme.spacing(1),
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  marginRight: theme.spacing(3),
  color: theme.palette.text.primary,
  fontSize: theme.typography.pxToRem(16),
  textDecoration: "none",
  marginTop: theme.spacing(2),
  "&:hover": {
    textDecoration: "none",
  },
})) as typeof Link;
